import debounce from 'lodash/debounce';

function handleMouseOut() {
	const coreMediaClasses = document.querySelectorAll('.cm-edit');
	if (coreMediaClasses) {
		for (const element of coreMediaClasses) {
			element.classList.remove('cm-edit');
		}
	}
}

function handleMouseOver(event) {
	if (event.ctrlKey) {
		let target = event.target;
		while (target && !target.hasAttribute('data-coremedia')) {
			target = target.parentElement;
		}
		if (target) {
			target.classList.add('cm-edit');
		}
	}
}

export default function coremediaEdit() {
	const baseUrl = window.location.origin;
	const isDevelopment = baseUrl !== 'https://librarian.springernature.com';

	const debouncedHandleMouseOut = debounce(handleMouseOut, 100);
	const debouncedHandleMouseOver = debounce(handleMouseOver, 100);

	const coreMediaSections = document.querySelectorAll('[data-coremedia]');

	if (isDevelopment) {
		for (const section of coreMediaSections) {
			section.style.border = 'none';
			section.addEventListener('mouseover', debouncedHandleMouseOver);
			section.addEventListener('mouseleave', debouncedHandleMouseOut);
		}
	}
}
